<template>
  <login :login-party="'customerLogin'"></login>
</template>

<script>
import login from "@/components/login/Login";
export default {
  components: { login }
};
</script>
